import React from "react";

const AlarmIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13.2252 12.7081L10.4169 11.0415V7.26646C10.4169 6.93313 10.1502 6.66646 9.81687 6.66646H9.76688C9.43354 6.66646 9.16688 6.93313 9.16688 7.26646V11.1998C9.16688 11.4915 9.31687 11.7665 9.57521 11.9165L12.6169 13.7415C12.9002 13.9081 13.2669 13.8248 13.4335 13.5415C13.6085 13.2498 13.5169 12.8748 13.2252 12.7081ZM17.6502 4.17479L15.0835 2.04146C14.7335 1.74979 14.2085 1.79146 13.9085 2.14979C13.6169 2.49979 13.6669 3.02479 14.0169 3.32479L16.5752 5.45812C16.9252 5.74979 17.4502 5.70812 17.7502 5.34979C18.0502 4.99979 18.0002 4.47479 17.6502 4.17479ZM3.41688 5.45812L5.97521 3.32479C6.33354 3.02479 6.38354 2.49979 6.08354 2.14979C5.79188 1.79146 5.26688 1.74979 4.91688 2.04146L2.35021 4.17479C2.00021 4.47479 1.95021 4.99979 2.25021 5.34979C2.54188 5.70812 3.06687 5.74979 3.41688 5.45812ZM10.0002 3.33312C5.85854 3.33312 2.50021 6.69146 2.50021 10.8331C2.50021 14.9748 5.85854 18.3331 10.0002 18.3331C14.1419 18.3331 17.5002 14.9748 17.5002 10.8331C17.5002 6.69146 14.1419 3.33312 10.0002 3.33312ZM10.0002 16.6665C6.78354 16.6665 4.16687 14.0498 4.16687 10.8331C4.16687 7.61646 6.78354 4.99979 10.0002 4.99979C13.2169 4.99979 15.8335 7.61646 15.8335 10.8331C15.8335 14.0498 13.2169 16.6665 10.0002 16.6665Z"
      fill="white"
      fillOpacity="0.56"
    />
  </svg>
);

const StrategyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.5 4.99984C12.5 5.45817 12.875 5.83317 13.3333 5.83317H16.6667C17.125 5.83317 17.5 5.45817 17.5 4.99984C17.5 4.5415 17.125 4.1665 16.6667 4.1665H13.3333C12.875 4.1665 12.5 4.5415 12.5 4.99984Z"
      fill="white"
      fillOpacity="0.56"
    />
    <path
      d="M7.98333 4.99984C7.68333 4.48317 7.13333 4.1665 6.54167 4.1665H3.33333C2.875 4.1665 2.5 4.5415 2.5 4.99984C2.5 5.45817 2.875 5.83317 3.33333 5.83317H6.54167L11.8333 14.9998C12.1333 15.5165 12.6833 15.8332 13.275 15.8332H16.6667C17.125 15.8332 17.5 15.4582 17.5 14.9998C17.5 14.5415 17.125 14.1665 16.6667 14.1665H13.275L7.98333 4.99984Z"
      fill="white"
      fillOpacity="0.56"
    />
  </svg>
);

const RadarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM10 16C6.69 16 4 13.31 4 10C4 6.69 6.69 4 10 4C13.31 4 16 6.69 16 10C16 13.31 13.31 16 10 16ZM10 6C7.79 6 6 7.79 6 10C6 12.21 7.79 14 10 14C12.21 14 14 12.21 14 10C14 7.79 12.21 6 10 6ZM10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8C11.1 8 12 8.9 12 10C12 11.1 11.1 12 10 12Z"
      fill="currentColor"
    />
  </svg>
);

const StorageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.33317 16.6668H16.6665C17.5832 16.6668 18.3332 15.9168 18.3332 15.0002C18.3332 14.0835 17.5832 13.3335 16.6665 13.3335H3.33317C2.4165 13.3335 1.6665 14.0835 1.6665 15.0002C1.6665 15.9168 2.4165 16.6668 3.33317 16.6668ZM3.33317 14.1668H4.99984V15.8335H3.33317V14.1668ZM1.6665 5.00016C1.6665 5.91683 2.4165 6.66683 3.33317 6.66683H16.6665C17.5832 6.66683 18.3332 5.91683 18.3332 5.00016C18.3332 4.0835 17.5832 3.3335 16.6665 3.3335H3.33317C2.4165 3.3335 1.6665 4.0835 1.6665 5.00016ZM4.99984 5.8335H3.33317V4.16683H4.99984V5.8335ZM3.33317 11.6668H16.6665C17.5832 11.6668 18.3332 10.9168 18.3332 10.0002C18.3332 9.0835 17.5832 8.3335 16.6665 8.3335H3.33317C2.4165 8.3335 1.6665 9.0835 1.6665 10.0002C1.6665 10.9168 2.4165 11.6668 3.33317 11.6668ZM3.33317 9.16683H4.99984V10.8335H3.33317V9.16683Z"
      fill="white"
      fillOpacity="0.56"
    />
  </svg>
);

const RationaleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99984 4.16667C9.53317 4.16667 9.1665 3.79167 9.1665 3.33333V2.5C9.1665 2.04167 9.5415 1.66667 9.99984 1.66667C10.4582 1.66667 10.8332 2.04167 10.8332 2.5V3.33333C10.8332 3.79167 10.4582 4.16667 9.99984 4.16667Z"
      fill="white"
      fillOpacity="0.56"
    />
    <path
      d="M4.99154 5.75834L4.39988 5.16667C4.07488 4.84167 4.07488 4.31667 4.39988 3.99167C4.72488 3.66667 5.24988 3.66667 5.57488 3.99167L6.16654 4.58334C6.49154 4.90834 6.49154 5.43334 6.16654 5.75834C5.84988 6.07501 5.31654 6.07501 4.99154 5.75834Z"
      fill="white"
      fillOpacity="0.56"
    />
    <path
      d="M4.1665 10C4.1665 10.4583 3.7915 10.8333 3.33317 10.8333H2.49984C2.0415 10.8333 1.6665 10.4583 1.6665 10C1.6665 9.54167 2.0415 9.16667 2.49984 9.16667H3.33317C3.7915 9.16667 4.1665 9.54167 4.1665 10Z"
      fill="white"
      fillOpacity="0.56"
    />
    <path
      d="M17.4998 10.8333H16.6665C16.2082 10.8333 15.8332 10.4583 15.8332 10C15.8332 9.54167 16.2082 9.16667 16.6665 9.16667H17.4998C17.9582 9.16667 18.3332 9.54167 18.3332 10C18.3332 10.4583 17.9582 10.8333 17.4998 10.8333Z"
      fill="white"
      fillOpacity="0.56"
    />
    <path
      d="M15.0082 5.75835C14.6832 6.08335 14.1582 6.08335 13.8332 5.75835C13.5082 5.43335 13.5082 4.90835 13.8332 4.58335L14.4248 3.99168C14.7498 3.66668 15.2748 3.66668 15.5998 3.99168C15.9248 4.31668 15.9248 4.84168 15.5998 5.16668L15.0082 5.75835Z"
      fill="white"
      fillOpacity="0.56"
    />
    <path
      d="M12.4998 13.3167V15.8333C12.4998 16.75 11.7498 17.5 10.8331 17.5H9.16647C8.2498 17.5 7.4998 16.75 7.4998 15.8333V13.3167C6.30813 12.4167 5.5998 10.9 5.90813 9.225C6.20813 7.6 7.49147 6.26667 9.10813 5.93333C11.7998 5.36667 14.1665 7.40833 14.1665 10C14.1665 11.3583 13.5081 12.55 12.4998 13.3167ZM10.8331 14.0833C10.5665 14.1333 10.2831 14.1667 9.9998 14.1667C9.71647 14.1667 9.43313 14.1333 9.16647 14.0833V15.8333H10.8331V14.0833Z"
      fill="white"
      fillOpacity="0.56"
    />
  </svg>
);

const SecurityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.325 1.1335L3.49167 3.72516C2.89167 3.99183 2.5 4.59183 2.5 5.25016V9.16683C2.5 13.7918 5.7 18.1168 10 19.1668C14.3 18.1168 17.5 13.7918 17.5 9.16683V5.25016C17.5 4.59183 17.1083 3.99183 16.5083 3.72516L10.675 1.1335C10.25 0.941829 9.75 0.941829 9.325 1.1335ZM10 9.99183H15.8333C15.3917 13.4252 13.1 16.4835 10 17.4418V10.0002H4.16667V5.25016L10 2.6585V9.99183Z"
      fill="white"
      fillOpacity="0.56"
    />
  </svg>
);

const AppStoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="40"
    viewBox="0 0 120 40"
    fill="none"
  >
    <path
      d="M110.135 0.00013H9.53468C9.16798 0.00013 8.80568 0.00013 8.43995 0.00213C8.1338 0.00413 7.83009 0.00994 7.521 0.01483C6.84951 0.0227318 6.17961 0.0818063 5.5171 0.19154C4.85552 0.303663 4.21467 0.515046 3.61622 0.81854C3.0185 1.1246 2.47235 1.5223 1.99757 1.9972C1.5203 2.47077 1.12246 3.01815 0.81935 3.61829C0.5154 4.21724 0.304641 4.85907 0.19435 5.52161C0.0830109 6.18332 0.0230984 6.85265 0.01515 7.52361C0.00587 7.83021 0.00489 8.13783 0 8.44447V31.5587C0.00489 31.8692 0.00587 32.17 0.01515 32.4806C0.0231008 33.1516 0.0830134 33.8209 0.19435 34.4825C0.304336 35.1455 0.515108 35.7877 0.81935 36.3868C1.12233 36.985 1.52022 37.5302 1.99757 38.0011C2.47054 38.4781 3.01705 38.8761 3.61622 39.1798C4.21467 39.4841 4.85545 39.6968 5.5171 39.8106C6.17972 39.9195 6.84956 39.9786 7.521 39.9874C7.83009 39.9942 8.1338 39.9981 8.43995 39.9981C8.80567 40.0001 9.168 40.0001 9.53468 40.0001H110.135C110.494 40.0001 110.859 40.0001 111.219 39.9981C111.523 39.9981 111.836 39.9942 112.141 39.9874C112.811 39.9791 113.479 39.92 114.141 39.8106C114.804 39.696 115.448 39.4834 116.049 39.1798C116.647 38.8759 117.193 38.478 117.666 38.0011C118.142 37.5284 118.541 36.9836 118.848 36.3868C119.15 35.7872 119.358 35.1451 119.467 34.4825C119.578 33.8208 119.64 33.1516 119.652 32.4806C119.656 32.17 119.656 31.8692 119.656 31.5587C119.664 31.1954 119.664 30.8341 119.664 30.4649V9.53626C119.664 9.17005 119.664 8.80677 119.656 8.44447C119.656 8.13783 119.656 7.83021 119.652 7.52357C119.64 6.85255 119.578 6.18337 119.467 5.52157C119.358 4.85941 119.149 4.21763 118.848 3.61825C118.23 2.41533 117.252 1.43616 116.049 0.81845C115.448 0.515697 114.804 0.30437 114.141 0.19145C113.48 0.0812328 112.811 0.0221378 112.141 0.01469C111.836 0.00981 111.523 0.00395 111.219 0.002C110.859 0 110.494 0 110.135 0V0.00013Z"
      fill="#A6A6A6"
    />
    <path
      d="M8.44487 39.125C8.14019 39.125 7.84287 39.1211 7.54058 39.1143C6.91436 39.1061 6.2896 39.0516 5.67144 38.9512C5.09503 38.8519 4.53664 38.6673 4.0147 38.4033C3.49754 38.1415 3.02585 37.7983 2.6177 37.3867C2.20364 36.98 1.85891 36.5082 1.59719 35.9902C1.33258 35.4688 1.14945 34.9099 1.05419 34.333C0.951311 33.7131 0.895651 33.0863 0.887687 32.458C0.881347 32.2471 0.873047 31.5449 0.873047 31.5449V8.44434C0.873047 8.44434 0.881887 7.75293 0.887737 7.5498C0.895363 6.92248 0.950699 6.29665 1.05327 5.67773C1.14871 5.09925 1.33197 4.53875 1.59673 4.01563C1.85749 3.49794 2.2003 3.02586 2.61187 2.61768C3.02297 2.20562 3.49617 1.8606 4.01421 1.59521C4.53495 1.33209 5.09228 1.14873 5.66753 1.05127C6.28772 0.949836 6.91465 0.894996 7.54304 0.88721L8.44536 0.875H111.214L112.127 0.8877C112.75 0.895099 113.371 0.94945 113.985 1.05029C114.566 1.14898 115.13 1.33362 115.656 1.59814C116.694 2.13299 117.539 2.97916 118.071 4.01807C118.332 4.53758 118.512 5.09351 118.607 5.66699C118.71 6.29099 118.768 6.92174 118.78 7.5542C118.783 7.8374 118.783 8.1416 118.783 8.44434C118.791 8.81934 118.791 9.17627 118.791 9.53613V30.4648C118.791 30.8281 118.791 31.1826 118.783 31.54C118.783 31.8652 118.783 32.1631 118.779 32.4697C118.768 33.0909 118.711 33.7104 118.608 34.3232C118.515 34.9043 118.333 35.4675 118.068 35.9932C117.805 36.5056 117.462 36.9733 117.053 37.3789C116.644 37.7927 116.172 38.1379 115.653 38.4014C115.128 38.6674 114.566 38.8527 113.985 38.9512C113.367 39.0522 112.742 39.1067 112.116 39.1143C111.823 39.1211 111.517 39.125 111.219 39.125L110.135 39.127L8.44487 39.125Z"
      fill="black"
    />
    <path
      d="M24.769 20.3008C24.7797 19.4662 25.0014 18.6478 25.4135 17.9218C25.8255 17.1959 26.4145 16.5859 27.1256 16.1488C26.6738 15.5036 26.0779 14.9727 25.385 14.5981C24.6922 14.2236 23.9216 14.0157 23.1344 13.9911C21.4552 13.8148 19.8272 14.9959 18.9715 14.9959C18.0992 14.9959 16.7817 14.0086 15.363 14.0378C14.4453 14.0674 13.551 14.3343 12.7671 14.8123C11.9832 15.2904 11.3365 15.9633 10.8901 16.7656C8.95607 20.1141 10.3987 25.0351 12.2513 27.7417C13.1782 29.0671 14.2615 30.5475 15.6789 30.495C17.066 30.4375 17.584 29.6105 19.2583 29.6105C20.9171 29.6105 21.4031 30.495 22.8493 30.4616C24.3377 30.4375 25.2754 29.1304 26.1698 27.7925C26.8358 26.8481 27.3483 25.8044 27.6882 24.7C26.8235 24.3343 26.0856 23.7221 25.5665 22.9398C25.0474 22.1575 24.77 21.2397 24.769 20.3008Z"
      fill="white"
    />
    <path
      d="M22.0376 12.2108C22.8491 11.2366 23.2489 9.98445 23.1521 8.72021C21.9123 8.85044 20.767 9.44299 19.9445 10.3798C19.5424 10.8375 19.2344 11.3699 19.0381 11.9467C18.8419 12.5235 18.7612 13.1333 18.8008 13.7412C19.4209 13.7476 20.0344 13.6132 20.5951 13.3481C21.1558 13.083 21.649 12.6942 22.0376 12.2108Z"
      fill="white"
    />
    <path
      d="M42.3022 27.1397H37.5688L36.4321 30.4961H34.4272L38.9106 18.0781H40.9936L45.477 30.4961H43.438L42.3022 27.1397ZM38.0591 25.5908H41.8111L39.9615 20.1436H39.9097L38.0591 25.5908Z"
      fill="white"
    />
    <path
      d="M55.1597 25.9699C55.1597 28.7834 53.6538 30.591 51.3814 30.591C50.8057 30.6211 50.2332 30.4885 49.7294 30.2084C49.2256 29.9283 48.8109 29.5119 48.5327 29.007H48.4897V33.4914H46.6313V21.4426H48.4302V22.9485H48.4644C48.7553 22.446 49.1771 22.0318 49.6847 21.7499C50.1923 21.4681 50.7669 21.3291 51.3472 21.3479C53.645 21.3479 55.1597 23.1643 55.1597 25.9699ZM53.2495 25.9699C53.2495 24.1369 52.3023 22.9319 50.857 22.9319C49.437 22.9319 48.482 24.1623 48.482 25.9699C48.482 27.7942 49.437 29.0158 50.857 29.0158C52.3023 29.0158 53.2495 27.8196 53.2495 25.9699Z"
      fill="white"
    />
    <path
      d="M65.1245 25.9699C65.1245 28.7834 63.6187 30.591 61.3462 30.591C60.7706 30.6211 60.1981 30.4885 59.6943 30.2084C59.1905 29.9283 58.7758 29.5119 58.4976 29.007H58.4546V33.4914H56.5962V21.4426H58.395V22.9484H58.4292C58.7201 22.446 59.1419 22.0318 59.6495 21.7499C60.1571 21.4681 60.7317 21.3291 61.312 21.3479C63.6099 21.3479 65.1245 23.1643 65.1245 25.9699ZM63.2144 25.9699C63.2144 24.1369 62.2671 22.9318 60.8218 22.9318C59.4019 22.9318 58.4468 24.1623 58.4468 25.9699C58.4468 27.7942 59.4019 29.0158 60.8218 29.0158C62.2671 29.0158 63.2144 27.8195 63.2144 25.9699H63.2144Z"
      fill="white"
    />
    <path
      d="M71.7105 27.0362C71.8482 28.2676 73.0445 29.0762 74.6792 29.0762C76.2456 29.0762 77.3726 28.2676 77.3726 27.1572C77.3726 26.1934 76.6929 25.6162 75.0835 25.2207L73.4742 24.833C71.1939 24.2822 70.1353 23.2158 70.1353 21.4854C70.1353 19.3428 72.0025 17.8711 74.6538 17.8711C77.2778 17.8711 79.0767 19.3428 79.1372 21.4854H77.2612C77.1489 20.2461 76.1245 19.4981 74.6274 19.4981C73.1304 19.4981 72.106 20.2549 72.106 21.3565C72.106 22.2344 72.7603 22.751 74.3608 23.1465L75.729 23.4824C78.2769 24.0849 79.3355 25.1084 79.3355 26.9248C79.3355 29.248 77.4849 30.7031 74.5415 30.7031C71.7876 30.7031 69.9282 29.2822 69.8081 27.0361L71.7105 27.0362Z"
      fill="white"
    />
    <path
      d="M83.3462 19.2998V21.4424H85.0679V22.9141H83.3462V27.9053C83.3462 28.6807 83.6909 29.042 84.4477 29.042C84.6521 29.0384 84.8562 29.0241 85.0591 28.999V30.4619C84.7188 30.5255 84.3729 30.5543 84.0268 30.5478C82.1938 30.5478 81.479 29.8593 81.479 28.1035V22.9141H80.1626V21.4424H81.479V19.2998H83.3462Z"
      fill="white"
    />
    <path
      d="M86.0649 25.9697C86.0649 23.1211 87.7427 21.3311 90.3589 21.3311C92.9839 21.3311 94.6538 23.1211 94.6538 25.9697C94.6538 28.8262 92.9927 30.6084 90.3589 30.6084C87.726 30.6084 86.0649 28.8262 86.0649 25.9697ZM92.7602 25.9697C92.7602 24.0156 91.8647 22.8623 90.3589 22.8623C88.853 22.8623 87.9585 24.0244 87.9585 25.9697C87.9585 27.9316 88.853 29.0762 90.3589 29.0762C91.8647 29.0762 92.7602 27.9316 92.7602 25.9697H92.7602Z"
      fill="white"
    />
    <path
      d="M96.186 21.4425H97.9585V22.9835H98.0015C98.1214 22.5022 98.4034 22.0769 98.8 21.779C99.1966 21.4811 99.6836 21.3288 100.179 21.3478C100.393 21.347 100.607 21.3703 100.816 21.4171V23.1554C100.546 23.0728 100.264 23.0348 99.981 23.0431C99.711 23.0321 99.4418 23.0797 99.192 23.1826C98.9421 23.2855 98.7175 23.4412 98.5335 23.6391C98.3496 23.837 98.2106 24.0724 98.1262 24.3291C98.0417 24.5857 98.0139 24.8576 98.0444 25.1261V30.4962H96.186L96.186 21.4425Z"
      fill="white"
    />
    <path
      d="M109.384 27.8369C109.134 29.4805 107.534 30.6084 105.486 30.6084C102.852 30.6084 101.217 28.8437 101.217 26.0127C101.217 23.1729 102.861 21.3311 105.408 21.3311C107.913 21.3311 109.488 23.0518 109.488 25.7969V26.4336H103.093V26.5459C103.064 26.8791 103.105 27.2148 103.216 27.5306C103.326 27.8464 103.502 28.1352 103.732 28.3778C103.963 28.6203 104.242 28.8111 104.552 28.9374C104.861 29.0637 105.195 29.1226 105.529 29.1103C105.968 29.1515 106.409 29.0498 106.785 28.8203C107.162 28.5909 107.455 28.246 107.62 27.8369L109.384 27.8369ZM103.102 25.1348H107.628C107.645 24.8352 107.6 24.5354 107.495 24.2541C107.39 23.9729 107.229 23.7164 107.02 23.5006C106.812 23.2849 106.561 23.1145 106.283 23.0003C106.006 22.8861 105.708 22.8305 105.408 22.8369C105.105 22.8351 104.805 22.8933 104.525 23.008C104.245 23.1227 103.99 23.2918 103.776 23.5054C103.562 23.7191 103.392 23.973 103.276 24.2527C103.16 24.5323 103.101 24.8321 103.102 25.1348V25.1348Z"
      fill="white"
    />
    <path
      d="M37.8262 8.73089C38.2158 8.70293 38.6067 8.76179 38.9709 8.90323C39.335 9.04466 39.6632 9.26514 39.9317 9.54876C40.2003 9.83239 40.4026 10.1721 40.524 10.5434C40.6454 10.9146 40.6829 11.3082 40.6338 11.6957C40.6338 13.602 39.6035 14.6977 37.8262 14.6977H35.6709V8.73089H37.8262ZM36.5976 13.8539H37.7226C38.0011 13.8705 38.2797 13.8249 38.5382 13.7203C38.7967 13.6157 39.0287 13.4547 39.2172 13.2491C39.4057 13.0436 39.546 12.7986 39.6278 12.532C39.7097 12.2653 39.7311 11.9838 39.6904 11.7079C39.7281 11.4331 39.7046 11.1533 39.6215 10.8886C39.5383 10.624 39.3977 10.381 39.2096 10.177C39.0216 9.9731 38.7907 9.81329 38.5337 9.70905C38.2766 9.60481 37.9996 9.55873 37.7226 9.5741H36.5976V13.8539Z"
      fill="white"
    />
    <path
      d="M41.6805 12.4443C41.6521 12.1484 41.686 11.8498 41.7798 11.5677C41.8737 11.2857 42.0254 11.0263 42.2254 10.8063C42.4253 10.5864 42.669 10.4106 42.9409 10.2903C43.2127 10.17 43.5067 10.1079 43.804 10.1079C44.1013 10.1079 44.3952 10.17 44.6671 10.2903C44.939 10.4106 45.1827 10.5864 45.3826 10.8063C45.5825 11.0263 45.7343 11.2857 45.8281 11.5677C45.922 11.8498 45.9558 12.1484 45.9275 12.4443C45.9564 12.7405 45.9229 13.0395 45.8293 13.322C45.7357 13.6045 45.5841 13.8644 45.3841 14.0848C45.1841 14.3052 44.9402 14.4813 44.6681 14.6019C44.3959 14.7224 44.1016 14.7847 43.804 14.7847C43.5064 14.7847 43.212 14.7224 42.9399 14.6019C42.6678 14.4813 42.4239 14.3052 42.2239 14.0848C42.0239 13.8644 41.8722 13.6045 41.7786 13.322C41.6851 13.0395 41.6516 12.7405 41.6805 12.4443ZM45.0135 12.4443C45.0135 11.4682 44.575 10.8974 43.8055 10.8974C43.033 10.8974 42.5985 11.4682 42.5985 12.4443C42.5985 13.4282 43.033 13.9946 43.8055 13.9946C44.575 13.9946 45.0135 13.4243 45.0135 12.4443H45.0135Z"
      fill="white"
    />
    <path
      d="M51.5732 14.6978H50.6514L49.7207 11.3813H49.6504L48.7236 14.6978H47.8105L46.5693 10.1948H47.4707L48.2773 13.6308H48.3438L49.2695 10.1948H50.1221L51.0479 13.6308H51.1182L51.9209 10.1948H52.8096L51.5732 14.6978Z"
      fill="white"
    />
    <path
      d="M53.8535 10.1949H54.709V10.9102H54.7754C54.888 10.6533 55.0781 10.4379 55.3189 10.2941C55.5598 10.1503 55.8395 10.0852 56.1191 10.1079C56.3382 10.0915 56.5582 10.1245 56.7628 10.2046C56.9674 10.2847 57.1514 10.4098 57.3011 10.5707C57.4508 10.7315 57.5623 10.924 57.6275 11.1338C57.6927 11.3436 57.7099 11.5654 57.6777 11.7827V14.6977H56.7891V12.0059C56.7891 11.2823 56.4746 10.9224 55.8174 10.9224C55.6686 10.9155 55.5201 10.9408 55.3821 10.9966C55.244 11.0525 55.1197 11.1375 55.0175 11.2459C54.9154 11.3543 54.8379 11.4834 54.7904 11.6246C54.7429 11.7657 54.7264 11.9154 54.7422 12.0635V14.6978H53.8535L53.8535 10.1949Z"
      fill="white"
    />
    <path d="M59.0938 8.43701H59.9824V14.6978H59.0938V8.43701Z" fill="white" />
    <path
      d="M61.2175 12.4444C61.1893 12.1484 61.2231 11.8499 61.317 11.5678C61.4109 11.2857 61.5626 11.0263 61.7626 10.8064C61.9626 10.5864 62.2063 10.4106 62.4782 10.2903C62.75 10.17 63.044 10.1079 63.3413 10.1079C63.6386 10.1079 63.9326 10.17 64.2045 10.2903C64.4764 10.4106 64.7201 10.5864 64.92 10.8064C65.12 11.0263 65.2718 11.2857 65.3656 11.5678C65.4595 11.8499 65.4934 12.1484 65.4651 12.4444C65.4939 12.7406 65.4604 13.0396 65.3668 13.3221C65.2732 13.6046 65.1215 13.8645 64.9215 14.0849C64.7215 14.3053 64.4776 14.4814 64.2054 14.6019C63.9333 14.7225 63.639 14.7847 63.3413 14.7847C63.0437 14.7847 62.7493 14.7225 62.4772 14.6019C62.2051 14.4814 61.9612 14.3053 61.7612 14.0849C61.5611 13.8645 61.4095 13.6046 61.3158 13.3221C61.2222 13.0396 61.1887 12.7406 61.2175 12.4444ZM64.5505 12.4444C64.5505 11.4683 64.1121 10.8975 63.3425 10.8975C62.5701 10.8975 62.1355 11.4683 62.1355 12.4444C62.1355 13.4283 62.5701 13.9947 63.3425 13.9947C64.1121 13.9947 64.5505 13.4244 64.5505 12.4444H64.5505Z"
      fill="white"
    />
    <path
      d="M66.4009 13.4243C66.4009 12.6138 67.0044 12.1465 68.0757 12.0801L69.2954 12.0098V11.6211C69.2954 11.1455 68.981 10.877 68.3735 10.877C67.8774 10.877 67.5337 11.0591 67.4351 11.3774H66.5747C66.6655 10.604 67.3931 10.1079 68.4146 10.1079C69.5435 10.1079 70.1802 10.6699 70.1802 11.6211V14.6978H69.3247V14.0649H69.2544C69.1117 14.2919 68.9113 14.477 68.6737 14.6012C68.436 14.7254 68.1697 14.7843 67.9019 14.7719C67.7128 14.7916 67.5218 14.7714 67.341 14.7127C67.1602 14.654 66.9938 14.5581 66.8524 14.4311C66.711 14.3042 66.5977 14.149 66.52 13.9756C66.4422 13.8021 66.4016 13.6144 66.4009 13.4243ZM69.2954 13.0395V12.6631L68.1958 12.7334C67.5757 12.7749 67.2944 12.9858 67.2944 13.3828C67.2944 13.7881 67.646 14.0239 68.1294 14.0239C68.2711 14.0382 68.4142 14.0239 68.5502 13.9819C68.6862 13.9398 68.8123 13.8707 68.9211 13.7789C69.0299 13.6871 69.1191 13.5743 69.1834 13.4473C69.2477 13.3202 69.2858 13.1816 69.2954 13.0395Z"
      fill="white"
    />
    <path
      d="M71.3481 12.4444C71.3481 11.0215 72.0796 10.1201 73.2173 10.1201C73.4987 10.1072 73.778 10.1746 74.0225 10.3145C74.267 10.4544 74.4667 10.661 74.5981 10.9101H74.6646V8.43701H75.5532V14.6978H74.7017V13.9863H74.6314C74.4897 14.2338 74.2831 14.4378 74.0339 14.5763C73.7846 14.7148 73.5022 14.7825 73.2173 14.772C72.0718 14.772 71.3481 13.8706 71.3481 12.4444ZM72.2661 12.4444C72.2661 13.3994 72.7163 13.9741 73.4693 13.9741C74.2183 13.9741 74.6812 13.3911 74.6812 12.4483C74.6812 11.5098 74.2134 10.9185 73.4693 10.9185C72.7212 10.9185 72.2661 11.4971 72.2661 12.4444H72.2661Z"
      fill="white"
    />
    <path
      d="M79.2298 12.4443C79.2015 12.1484 79.2353 11.8498 79.3292 11.5677C79.423 11.2857 79.5748 11.0263 79.7747 10.8063C79.9746 10.5864 80.2183 10.4106 80.4902 10.2903C80.762 10.17 81.056 10.1079 81.3533 10.1079C81.6506 10.1079 81.9446 10.17 82.2164 10.2903C82.4883 10.4106 82.732 10.5864 82.9319 10.8063C83.1319 11.0263 83.2836 11.2857 83.3775 11.5677C83.4713 11.8498 83.5052 12.1484 83.4768 12.4443C83.5057 12.7405 83.4722 13.0395 83.3786 13.322C83.2851 13.6045 83.1334 13.8644 82.9334 14.0848C82.7334 14.3052 82.4895 14.4813 82.2174 14.6019C81.9453 14.7224 81.6509 14.7847 81.3533 14.7847C81.0557 14.7847 80.7613 14.7224 80.4892 14.6019C80.2171 14.4813 79.9732 14.3052 79.7732 14.0848C79.5732 13.8644 79.4216 13.6045 79.328 13.322C79.2344 13.0395 79.2009 12.7405 79.2298 12.4443ZM82.5628 12.4443C82.5628 11.4682 82.1243 10.8974 81.3548 10.8974C80.5823 10.8974 80.1478 11.4682 80.1478 12.4443C80.1478 13.4282 80.5823 13.9946 81.3548 13.9946C82.1243 13.9946 82.5628 13.4243 82.5628 12.4443Z"
      fill="white"
    />
    <path
      d="M84.6694 10.1949H85.5249V10.9102H85.5913C85.704 10.6533 85.894 10.4379 86.1348 10.2941C86.3757 10.1503 86.6555 10.0852 86.9351 10.1079C87.1542 10.0915 87.3742 10.1245 87.5788 10.2046C87.7834 10.2847 87.9673 10.4098 88.117 10.5707C88.2667 10.7315 88.3783 10.924 88.4435 11.1338C88.5087 11.3436 88.5258 11.5654 88.4937 11.7827V14.6977H87.605V12.0059C87.605 11.2823 87.2905 10.9224 86.6333 10.9224C86.4846 10.9155 86.336 10.9408 86.198 10.9966C86.0599 11.0525 85.9356 11.1375 85.8335 11.2459C85.7313 11.3543 85.6539 11.4834 85.6063 11.6246C85.5588 11.7657 85.5423 11.9154 85.5581 12.0635V14.6978H84.6694V10.1949Z"
      fill="white"
    />
    <path
      d="M93.5151 9.07373V10.2153H94.4907V10.9639H93.5151V13.2793C93.5151 13.751 93.7095 13.9575 94.1519 13.9575C94.2651 13.9572 94.3783 13.9503 94.4907 13.937V14.6772C94.3311 14.7058 94.1694 14.721 94.0073 14.7226C93.019 14.7226 92.6255 14.375 92.6255 13.5068V10.9638H91.9106V10.2153H92.6255V9.07373H93.5151Z"
      fill="white"
    />
    <path
      d="M95.7046 8.43701H96.5854V10.9185H96.6558C96.7739 10.6591 96.9691 10.4425 97.2148 10.2982C97.4605 10.1539 97.7447 10.0888 98.0288 10.1118C98.2467 10.1 98.4646 10.1364 98.6669 10.2184C98.8692 10.3004 99.0508 10.4261 99.199 10.5864C99.3471 10.7468 99.458 10.9378 99.5238 11.146C99.5896 11.3541 99.6086 11.5742 99.5795 11.7905V14.6978H98.69V12.0098C98.69 11.2905 98.355 10.9263 97.7271 10.9263C97.5743 10.9137 97.4207 10.9347 97.2769 10.9878C97.1332 11.0408 97.0027 11.1247 96.8947 11.2334C96.7867 11.3421 96.7038 11.4732 96.6517 11.6173C96.5997 11.7614 96.5797 11.9152 96.5933 12.0679V14.6977H95.7046L95.7046 8.43701Z"
      fill="white"
    />
    <path
      d="M104.761 13.482C104.641 13.8935 104.379 14.2495 104.022 14.4877C103.666 14.7258 103.237 14.831 102.81 14.7847C102.514 14.7926 102.219 14.7357 101.946 14.6182C101.674 14.5007 101.43 14.3253 101.232 14.1041C101.034 13.883 100.887 13.6214 100.8 13.3376C100.713 13.0538 100.69 12.7545 100.73 12.4605C100.691 12.1656 100.715 11.8657 100.801 11.581C100.888 11.2964 101.035 11.0336 101.231 10.8105C101.428 10.5874 101.671 10.4093 101.943 10.2881C102.214 10.1669 102.509 10.1054 102.806 10.108C104.059 10.108 104.815 10.964 104.815 12.378V12.6881H101.635V12.7379C101.621 12.9031 101.642 13.0695 101.696 13.2262C101.751 13.383 101.837 13.5267 101.95 13.6481C102.063 13.7696 102.2 13.8661 102.352 13.9315C102.504 13.9969 102.669 14.0297 102.835 14.0279C103.047 14.0534 103.263 14.0151 103.453 13.9179C103.644 13.8207 103.802 13.669 103.906 13.482L104.761 13.482ZM101.635 12.0308H103.91C103.921 11.8797 103.9 11.7279 103.85 11.5852C103.799 11.4425 103.718 11.312 103.614 11.2021C103.51 11.0923 103.383 11.0055 103.243 10.9473C103.103 10.8891 102.953 10.8609 102.801 10.8643C102.648 10.8624 102.495 10.8913 102.353 10.9492C102.21 11.0072 102.081 11.093 101.972 11.2017C101.864 11.3104 101.778 11.4398 101.72 11.5822C101.662 11.7246 101.633 11.8771 101.635 12.0308H101.635Z"
      fill="white"
    />
  </svg>
);

const GooglePlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="135"
    height="40"
    viewBox="0 0 135 40"
    fill="none"
  >
    <g clipPath="url(#clip0_1925_30726)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.998 40H5.00184C2.24512 40 0 37.7456 0 35V5C0 2.24439 2.24512 0 5.00184 0H129.998C132.752 0 135 2.24439 135 5V35C135 37.7456 132.752 40 129.998 40Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.998 0.800499C132.31 0.800499 134.203 2.68828 134.203 5V35C134.203 37.3117 132.323 39.1995 129.998 39.1995H5.00184C2.68967 39.1995 0.797215 37.3117 0.797215 35V5C0.797215 2.68828 2.67725 0.800499 5.00184 0.800499H129.998ZM129.998 0H5.00184C2.24512 0 0 2.25436 0 5V35C0 37.7556 2.24512 40 5.00184 40H129.998C132.752 40 135 37.7556 135 35V5C135 2.25436 132.752 0 129.998 0Z"
        fill="#A6A6A6"
      />
      <path
        d="M71.1182 13.232C70.2167 13.232 69.4567 12.9153 68.8557 12.2918C68.2596 11.6858 67.9268 10.8504 67.9417 9.99755C67.9417 9.08732 68.2497 8.31675 68.8557 7.70577C69.4542 7.08233 70.2142 6.76562 71.1157 6.76562C72.0073 6.76562 72.7672 7.08233 73.3782 7.70577C73.9841 8.3367 74.2921 9.10727 74.2921 9.99755C74.2822 10.9103 73.9742 11.6808 73.3782 12.2893C72.7796 12.9177 72.0197 13.232 71.1182 13.232ZM44.2937 13.232C43.412 13.232 42.6471 12.9202 42.0212 12.3043C41.4004 11.6908 41.085 10.9153 41.085 10C41.085 9.08483 41.4004 8.30927 42.0212 7.6958C42.6347 7.07984 43.3996 6.76812 44.2937 6.76812C44.7308 6.76812 45.1554 6.8554 45.5627 7.03246C45.9626 7.20453 46.2879 7.43894 46.5288 7.72572L46.5884 7.79804L45.9154 8.46139L45.8459 8.37909C45.4659 7.92523 44.9568 7.70328 44.2837 7.70328C43.6827 7.70328 43.1587 7.91774 42.7266 8.34169C42.292 8.76812 42.0709 9.32672 42.0709 10.0025C42.0709 10.6783 42.292 11.2369 42.7266 11.6634C43.1587 12.0873 43.6827 12.3018 44.2837 12.3018C44.9245 12.3018 45.4634 12.0873 45.8831 11.6634C46.1315 11.414 46.2855 11.0649 46.3401 10.6235H44.1819V9.69081H47.2664L47.2789 9.7756C47.3012 9.93271 47.3236 10.0948 47.3236 10.2444C47.3236 11.1048 47.0653 11.8005 46.5537 12.3143C45.9725 12.9227 45.2126 13.232 44.2937 13.232ZM79.9595 13.0998H79.0083L76.0951 8.41899L76.12 9.26188V13.0973H75.1688V6.90029H76.2541L76.2839 6.94767L79.0232 11.3566L78.9984 10.5162V6.90029H79.9595V13.0998ZM63.9706 13.0998H63.007V7.83296H61.3356V6.90029H65.6395V7.83296H63.9681V13.0998H63.9706ZM60.5508 13.0998H59.5897V6.90029H60.5508V13.0998ZM55.1491 13.0998H54.188V7.83296H52.5166V6.90029H56.8205V7.83296H55.1491V13.0998ZM51.9081 13.0898H48.2226V6.90029H51.9081V7.83296H49.1862V9.5337H51.6424V10.4564H49.1862V12.1571H51.9081V13.0898ZM69.561 11.6509C69.9906 12.0823 70.5122 12.2993 71.1182 12.2993C71.7415 12.2993 72.2507 12.0873 72.6753 11.6509C73.0975 11.227 73.3111 10.6709 73.3111 10C73.3111 9.32922 73.0975 8.77061 72.6778 8.34917C72.2482 7.91774 71.7241 7.70079 71.1206 7.70079C70.4973 7.70079 69.9882 7.91276 69.566 8.34917C69.1438 8.77311 68.9302 9.32922 68.9302 10C68.9302 10.6709 69.1413 11.2295 69.561 11.6509Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.8528 21.7554C65.5059 21.7554 63.6035 23.5434 63.6035 26.0098C63.6035 28.4537 65.5183 30.2641 67.8528 30.2641C70.1998 30.2641 72.1021 28.4636 72.1021 26.0098C72.1021 23.5434 70.1998 21.7554 67.8528 21.7554ZM67.8528 28.5784C66.5688 28.5784 65.4636 27.511 65.4636 25.9998C65.4636 24.4661 66.5713 23.4213 67.8528 23.4213C69.1368 23.4213 70.242 24.4661 70.242 25.9998C70.2445 27.521 69.1368 28.5784 67.8528 28.5784ZM58.5818 21.7554C56.2348 21.7554 54.3324 23.5434 54.3324 26.0098C54.3324 28.4537 56.2472 30.2641 58.5818 30.2641C60.9287 30.2641 62.8311 28.4636 62.8311 26.0098C62.8311 23.5434 60.9262 21.7554 58.5818 21.7554ZM58.5818 28.5784C57.2978 28.5784 56.1926 27.511 56.1926 25.9998C56.1926 24.4661 57.3003 23.4213 58.5818 23.4213C59.8658 23.4213 60.9709 24.4661 60.9709 25.9998C60.9709 27.521 59.8658 28.5784 58.5818 28.5784ZM47.5499 23.0547V24.8552H51.8539C51.7222 25.8651 51.3894 26.6108 50.8803 27.122C50.2495 27.7554 49.2759 28.4437 47.5598 28.4437C44.9149 28.4437 42.8461 26.2991 42.8461 23.6432C42.8461 20.9873 44.9149 18.8427 47.5598 18.8427C48.9879 18.8427 50.0285 19.4088 50.8008 20.132L52.0724 18.8552C50.9995 17.8227 49.5715 17.0322 47.5698 17.0322C43.9413 17.0322 40.8965 19.9998 40.8965 23.6332C40.8965 27.2766 43.9388 30.2342 47.5698 30.2342C49.5293 30.2342 50.9995 29.5908 52.1618 28.3789C53.3465 27.1893 53.7215 25.511 53.7215 24.1569C53.7215 23.7355 53.6892 23.3564 53.6221 23.0347H47.5474C47.5499 23.0322 47.5499 23.0547 47.5499 23.0547ZM92.6733 24.4562C92.3181 23.5011 91.2453 21.7454 89.0448 21.7454C86.8643 21.7454 85.0513 23.4686 85.0513 25.9998C85.0513 28.3888 86.8444 30.2542 89.2559 30.2542C91.1931 30.2542 92.3206 29.0646 92.7851 28.3664L91.3471 27.3988C90.8702 28.1095 90.2071 28.5759 89.2659 28.5759C88.3147 28.5759 87.6491 28.142 87.207 27.2866L92.872 24.93C92.872 24.9325 92.6733 24.4562 92.6733 24.4562ZM86.8966 25.8776C86.8519 24.2342 88.1682 23.3988 89.1094 23.3988C89.852 23.3988 90.4704 23.7654 90.6815 24.2991L86.8966 25.8776ZM82.2946 29.9998H84.1548V17.5011H82.2946V29.9998ZM79.2398 22.7006H79.1728C78.7531 22.1993 77.9558 21.7454 76.9376 21.7454C74.8241 21.7454 72.877 23.6133 72.877 26.0123C72.877 28.4013 74.8142 30.2467 76.9376 30.2467C77.9434 30.2467 78.7531 29.7903 79.1728 29.2791H79.2398V29.8901C79.2398 31.5135 78.3756 32.3888 76.9823 32.3888C75.8424 32.3888 75.1345 31.5659 74.8465 30.8776L73.2297 31.5559C73.6941 32.6781 74.9334 34.0671 76.9798 34.0671C79.1604 34.0671 81.0081 32.7779 81.0081 29.6332V21.9998H79.2498V22.7006C79.2523 22.7006 79.2398 22.7006 79.2398 22.7006ZM77.104 28.5784C75.82 28.5784 74.7471 27.5011 74.7471 26.0123C74.7471 24.511 75.82 23.4237 77.104 23.4237C78.3756 23.4237 79.3615 24.5235 79.3615 26.0123C79.3739 27.5011 78.378 28.5784 77.104 28.5784ZM101.383 17.5011H96.935V29.9998H98.7952V25.2666H101.386C103.444 25.2666 105.468 23.7679 105.468 21.3888C105.468 19.0098 103.452 17.5011 101.383 17.5011ZM101.438 23.521H98.7927V19.2317H101.438C102.831 19.2317 103.618 20.3863 103.618 21.3764C103.618 22.3564 102.821 23.521 101.438 23.521ZM112.924 21.733C111.573 21.733 110.18 22.334 109.604 23.6432L111.253 24.3315C111.608 23.6432 112.258 23.4088 112.946 23.4088C113.91 23.4088 114.884 23.9873 114.906 25.0198V25.1519C114.573 24.9624 113.843 24.6731 112.969 24.6731C111.188 24.6731 109.383 25.6507 109.383 27.4836C109.383 29.1619 110.843 30.2392 112.47 30.2392C113.719 30.2392 114.407 29.6731 114.836 29.0173H114.903V29.9848H116.697V25.1968C116.697 22.9674 115.047 21.733 112.924 21.733ZM112.691 28.5784C112.082 28.5784 111.23 28.2791 111.23 27.511C111.23 26.5434 112.293 26.1769 113.2 26.1769C114.019 26.1769 114.407 26.3539 114.894 26.5983C114.759 27.7205 113.816 28.5684 112.691 28.5784ZM123.238 21.9998L121.102 27.4213H121.035L118.822 21.9998H116.821L120.141 29.5784L118.249 33.7903H120.186L125.295 21.9998H123.238ZM106.494 29.9998H108.354V17.5011H106.494V29.9998Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.391 7.53364C10.1029 7.84536 9.93652 8.32167 9.93652 8.94511V31.0573C9.93652 31.6808 10.1029 32.1571 10.4009 32.4563L10.4779 32.5237L22.8161 20.1346V19.8578L10.468 7.46631L10.391 7.53364Z"
        fill="url(#paint0_linear_1925_30726)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9214 24.2768L22.8062 20.1446V19.8553L26.9214 15.7231L27.0108 15.778L31.8786 18.5561C33.2718 19.3441 33.2718 20.6458 31.8786 21.4438L27.0108 24.2219L26.9214 24.2768Z"
        fill="url(#paint1_linear_1925_30726)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0109 24.2219L22.8063 20L10.3911 32.4663C10.8456 32.9551 11.608 33.01 12.4599 32.5337L27.0109 24.2219Z"
        fill="url(#paint2_linear_1925_30726)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0109 15.7779L12.4599 7.47869C11.608 6.98992 10.8431 7.05725 10.3911 7.54603L22.8063 19.9999L27.0109 15.7779Z"
        fill="url(#paint3_linear_1925_30726)"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9214 24.1323L12.4697 32.3767C11.6625 32.843 10.9423 32.8106 10.4779 32.3867L10.4009 32.464L10.4779 32.5313C10.9423 32.9527 11.6625 32.9877 12.4697 32.5213L27.0208 24.2221L26.9214 24.1323Z"
        fill="black"
      />
      <path
        opacity="0.12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8787 21.2993L26.9092 24.1322L26.9986 24.2219L31.8663 21.4439C32.5642 21.0449 32.9069 20.5212 32.9069 20C32.8647 20.4788 32.5095 20.9327 31.8787 21.2993Z"
        fill="black"
      />
      <path
        opacity="0.25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4598 7.62329L31.8786 18.7006C32.5094 19.0572 32.8645 19.5235 32.9192 19.9999C32.9192 19.4787 32.5764 18.955 31.8786 18.556L12.4598 7.47866C11.0665 6.67816 9.93652 7.34649 9.93652 8.94499V9.08963C9.93652 7.48863 11.0665 6.83277 12.4598 7.62329Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1925_30726"
        x1="21.7094"
        y1="8.70654"
        x2="1.93502"
        y2="13.9538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.00657" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1925_30726"
        x1="33.6955"
        y1="20"
        x2="9.59777"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1925_30726"
        x1="24.7246"
        y1="22.2973"
        x2="8.76185"
        y2="49.0538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1925_30726"
        x1="7.26483"
        y1="0.178683"
        x2="14.3865"
        y2="12.1286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
      <clipPath id="clip0_1925_30726">
        <rect width="135" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DetailHomeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.33342 16.6667V11.6667H11.6667V16.6667H15.8334V10H18.3334L10.0001 2.5L1.66675 10H4.16675V16.6667H8.33342Z"
      fill="black"
      fill-opacity="0.56"
    />
  </svg>
);

const DetailOptionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.5 4.99984C12.5 5.45817 12.875 5.83317 13.3333 5.83317H16.6667C17.125 5.83317 17.5 5.45817 17.5 4.99984C17.5 4.5415 17.125 4.1665 16.6667 4.1665H13.3333C12.875 4.1665 12.5 4.5415 12.5 4.99984Z"
      fill="black"
      fill-opacity="0.56"
    />
    <path
      d="M7.98333 4.99984C7.68333 4.48317 7.13333 4.1665 6.54167 4.1665H3.33333C2.875 4.1665 2.5 4.5415 2.5 4.99984C2.5 5.45817 2.875 5.83317 3.33333 5.83317H6.54167L11.8333 14.9998C12.1333 15.5165 12.6833 15.8332 13.275 15.8332H16.6667C17.125 15.8332 17.5 15.4582 17.5 14.9998C17.5 14.5415 17.125 14.1665 16.6667 14.1665H13.275L7.98333 4.99984Z"
      fill="black"
      fill-opacity="0.56"
    />
  </svg>
);

const DetailArrowBackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 11.0002H7.82998L12.71 6.12021C13.1 5.73021 13.1 5.09021 12.71 4.70021C12.32 4.31021 11.69 4.31021 11.3 4.70021L4.70998 11.2902C4.31998 11.6802 4.31998 12.3102 4.70998 12.7002L11.3 19.2902C11.69 19.6802 12.32 19.6802 12.71 19.2902C13.1 18.9002 13.1 18.2702 12.71 17.8802L7.82998 13.0002H19C19.55 13.0002 20 12.5502 20 12.0002C20 11.4502 19.55 11.0002 19 11.0002Z"
      fill="black"
      fill-opacity="0.56"
    />
  </svg>
);

const DetailCopyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 1.33334H2.66667C1.93333 1.33334 1.33333 1.93334 1.33333 2.66668V11.3333H2.66667V2.66668H10.6667V1.33334ZM12.6667 4.00001H5.33333C4.6 4.00001 4 4.60001 4 5.33334V13.3333C4 14.0667 4.6 14.6667 5.33333 14.6667H12.6667C13.4 14.6667 14 14.0667 14 13.3333V5.33334C14 4.60001 13.4 4.00001 12.6667 4.00001ZM12.6667 13.3333H5.33333V5.33334H12.6667V13.3333Z"
      fill="currentColor"
    />
  </svg>
);

const DetailStarLightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.2166 6.6666L16.875 5.20827L18.3333 4.54994C18.6583 4.39994 18.6583 3.9416 18.3333 3.7916L16.875 3.13327L16.2166 1.6666C16.0666 1.3416 15.6083 1.3416 15.4583 1.6666L14.8 3.12494L13.3333 3.78327C13.0083 3.93327 13.0083 4.3916 13.3333 4.5416L14.7916 5.19993L15.45 6.6666C15.6 6.9916 16.0666 6.9916 16.2166 6.6666ZM9.58328 7.9166L8.25828 4.99994C7.96662 4.34994 7.03328 4.34994 6.74162 4.99994L5.41662 7.9166L2.49995 9.2416C1.84995 9.5416 1.84995 10.4666 2.49995 10.7583L5.41662 12.0833L6.74162 14.9999C7.04162 15.6499 7.96662 15.6499 8.25828 14.9999L9.58328 12.0833L12.5 10.7583C13.15 10.4583 13.15 9.53327 12.5 9.2416L9.58328 7.9166ZM15.45 13.3333L14.7916 14.7916L13.3333 15.4499C13.0083 15.5999 13.0083 16.0583 13.3333 16.2083L14.7916 16.8666L15.45 18.3333C15.6 18.6583 16.0583 18.6583 16.2083 18.3333L16.8666 16.8749L18.3333 16.2166C18.6583 16.0666 18.6583 15.6083 18.3333 15.4583L16.875 14.7999L16.2166 13.3333C16.0666 13.0083 15.6 13.0083 15.45 13.3333Z"
      fill="url(#paint0_linear_2047_1423)"
      fill-opacity="0.96"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2047_1423"
        x1="2.11421"
        y1="1.49453"
        x2="44.5671"
        y2="35.4714"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E3A396" />
        <stop offset="1" stop-color="#007BFF" />
      </linearGradient>
    </defs>
  </svg>
);

const DetailStarDarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.2169 6.6666L16.8752 5.20827L18.3335 4.54994C18.6585 4.39994 18.6585 3.9416 18.3335 3.7916L16.8752 3.13327L16.2169 1.6666C16.0669 1.3416 15.6085 1.3416 15.4585 1.6666L14.8002 3.12494L13.3335 3.78327C13.0085 3.93327 13.0085 4.3916 13.3335 4.5416L14.7919 5.19993L15.4502 6.6666C15.6002 6.9916 16.0669 6.9916 16.2169 6.6666ZM9.58353 7.9166L8.25853 4.99994C7.96686 4.34994 7.03353 4.34994 6.74186 4.99994L5.41686 7.9166L2.5002 9.2416C1.8502 9.5416 1.8502 10.4666 2.5002 10.7583L5.41686 12.0833L6.74186 14.9999C7.04186 15.6499 7.96686 15.6499 8.25853 14.9999L9.58353 12.0833L12.5002 10.7583C13.1502 10.4583 13.1502 9.53327 12.5002 9.2416L9.58353 7.9166ZM15.4502 13.3333L14.7919 14.7916L13.3335 15.4499C13.0085 15.5999 13.0085 16.0583 13.3335 16.2083L14.7919 16.8666L15.4502 18.3333C15.6002 18.6583 16.0585 18.6583 16.2085 18.3333L16.8669 16.8749L18.3335 16.2166C18.6585 16.0666 18.6585 15.6083 18.3335 15.4583L16.8752 14.7999L16.2169 13.3333C16.0669 13.0083 15.6002 13.0083 15.4502 13.3333Z"
      fill="url(#paint0_linear_2047_5128)"
      fill-opacity="0.96"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2047_5128"
        x1="2.11446"
        y1="1.49453"
        x2="44.5673"
        y2="35.4714"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCEDEC" />
        <stop offset="1" stop-color="#009EFF" />
      </linearGradient>
    </defs>
  </svg>
);

const TickerDetailChartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.5 16.5L9.5 10.5L13 14L18.5 7.5"
      stroke="black"
      strokeOpacity="0.87"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export {
  AlarmIcon,
  StrategyIcon,
  RadarIcon,
  StorageIcon,
  RationaleIcon,
  SecurityIcon,
  AppStoreIcon,
  GooglePlayIcon,
  DetailHomeIcon,
  DetailOptionIcon,
  DetailArrowBackIcon,
  DetailCopyIcon,
  DetailStarLightIcon,
  DetailStarDarkIcon,
  TickerDetailChartIcon,
};
